import "./HomePage.scss";
import Hero from "../../components/Hero/Hero";
import ExpertiseOverview from "../../components/ExpertiseOverview/ExpertiseOverview";

function HomePage() {

    return (
        <main>
            <Hero/>
            <ExpertiseOverview/>
        </main>
    )
}

export default HomePage;